<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
    
      <div *ngIf="loading" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <div class="spinner">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    
      <div *ngIf="!loading && selling && buying" class="left gallery-or-icon mdc-layout-grid__cell mdc-layout-grid__cell--span-8">
        
        <h1 i18n>Conversations</h1>
        <h2 i18n>I'm Selling</h2>
        
        <table mat-table [dataSource]="selling" style="margin-bottom: 36px;">
          
          <ng-container matColumnDef="image">
            <td mat-cell *matCellDef="let row">
              <div class="item-image" [matBadge]="row.totalUnreadMessages" [matBadgeHidden]="row.totalUnreadMessages === 0" matBadgeColor="accent">
                <img class="item-image"
                    *ngIf="row.item.pictures.length > 0" 
                    [src]="picturesUrl + '/' + row.item.pictures[0].key" 
                    (click)="viewListing(row.item.id)"/>
                    
                <mat-icon fontSet="material-symbols-outlined"
                  *ngIf="row.item.pictures.length === 0" 
                  (click)="viewListing(row.item.id)" 
                  class="item-image">{{row.item.fillerIconName}}</mat-icon>
              </div>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="title">
            <td mat-cell *matCellDef="let row">
              <a [routerLink]="['/chats/listings/' + row.item.id]">
                <div [style.font-weight]="row.totalUnreadMessages > 0 ? 'bold' : 'normal'">{{row.item.title}}</div>
                <div class="mat-subtitle-2" style="color:grey">{{row.item.price.toNumber() | currency : row.item.price.currency()}}</div>
              </a>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="numberOfMessages">
            <td mat-cell *matCellDef="let row">
              <a [routerLink]="['/chats/listings/' + row.item.id]">
                <span [style.font-weight]="row.totalUnreadMessages > 0 ? 'bold' : 'normal'">{{row.totalUnreadMessages}}</span>/{{row.totalMessages}}
              </a>
            </td>
          </ng-container>
          
          <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
        </table>
        
        <h2 *ngIf="buying.length > 0" i18n>I'm Buying</h2>
        <table mat-table [dataSource]="buying" style="margin-bottom: 36px;">
          
          <ng-container matColumnDef="image">
            <td mat-cell *matCellDef="let row" >
              <div class="item-image" [matBadge]="row.totalUnreadMessages" [matBadgeHidden]="row.totalUnreadMessages === 0" matBadgeColor="accent">
                <img class="item-image"
                    *ngIf="row.item.pictures.length > 0" 
                    [src]="picturesUrl + '/' + row.item.pictures[0].key" 
                    (click)="viewListing(row.item.id)"/>
                    
                <mat-icon fontSet="material-symbols-outlined"
                    *ngIf="row.item.pictures.length === 0" 
                    (click)="viewListing(row.item.id)" 
                    class="item-image">{{row.item.fillerIconName}}</mat-icon>
              </div>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="title">
            <td mat-cell *matCellDef="let row">
              <a [routerLink]="['/view-listing/' + row.item.id]">
                <div [style.font-weight]="row.totalUnreadMessages > 0 ? 'bold' : 'normal'">{{row.item.title}}</div>
              </a>
            </td>
          </ng-container>
          
          <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
        </table>
      </div>
    </div>
  </div>
</div>